import React, { Component } from 'react';

export const Header = ({ headings }) => (
  <div className="design-table-header">
    {
      headings.map(title => <div className="table-header-column">{title}</div>)
    }
  </div>
)
